import PropTypes from 'prop-types';

/**
 * Render a different component depending on the theme. We mainly use this for Brand/Marketing pages
 */
export const ThemeComponentToggle = ({ currentTheme = 'consumer', ...props }) => {
    return props[currentTheme] || props.consumer || null;
};
ThemeComponentToggle.propTypes = {
    currentTheme: PropTypes.string,
    consumer: PropTypes.node,
    saas: PropTypes.node,
    'saas-mono': PropTypes.node,
};

export default ThemeComponentToggle;
